export class PharmacyReport {
    saleDate: Date | string;
    totalAmount: number;
    totalTaxes: number;
    totalDiscount: number;
    totalNetAmount: number;
    paidVia: string;
    cgst: number;
    paymentNumber: string;
}